export type SolanaWalletId =
  | "phantom"
  | "solflare"
  | "backpack"
  | "trustWallet";

export type SolanaWalletOption = {
  id: SolanaWalletId;
  name: string;
  installUrl: string;
};

export const SOLANA_WALLET_OPTIONS: SolanaWalletOption[] = [
  {
    id: "phantom",
    name: "Phantom",
    installUrl: "https://phantom.app",
  },
  {
    id: "solflare",
    name: "Solflare",
    installUrl: "https://solflare.com",
  },
  {
    id: "backpack",
    name: "Backpack",
    installUrl: "https://backpack.app",
  },
  {
    id: "trustWallet",
    name: "Trust Wallet",
    installUrl: "https://trustwallet.com/browser-extension",
  },
];
